export default __webpack_public_path__ + "static/media/lahore.065624e0.png";